export default __webpack_public_path__ + "media/images/icon_likes-e933c7111e0ee9fa0dbce8f4ef9b4d15.png";